<template>
  <div>
    <v-container
      v-if="isLoading"
      class="d-flex justify-center align-center"
      style="height: 100vh;"
    >
      <v-progress-circular
        :size="100"
        color="#2661FF"
        indeterminate
      ></v-progress-circular>
    </v-container>
    <v-container v-else class="pa-0 ma-0">
      <BaseToolbar
        :title="getCardTitle(transaction)"
        @close="closeTransactionDetailDrawer"
        type-title="icon"
        backgroundColor="#2661FF"
      />
      <v-container class="pa-6">
        <v-card class="rounded-lg card" flat>
          <v-card-title class="justify-space-between">
            <div>
              <p class=" body-1 mt-4">{{ getCardTitle(transaction) }}</p>
            </div>
            <div>
              <v-btn
                v-show="isSubscription"
                class="rounded-lg"
                outlined
                color="#2661FF"
                @click="openSubscriptionEditorDrawer"
              >
                <span>
                  {{ $t("subscriptions.edit.title") }}
                </span>
              </v-btn>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="d-flex flex-column" style="gap: 12px;">
            <!-- TRANSACTION -->
            <InfoRow label="ID" :value="String(transaction.id)" />
            <InfoRow
              :label="$t('transactions.dashboard.type')"
              :value="getTransactionType(transaction)"
            />
            <InfoRow
              :label="$t('transactions.dashboard.gateway')"
              :value="getGatewayName(transaction)"
            />
            <InfoRow
              :label="$t('transactions.dashboard.amount')"
              :value="
                formatCurrencyCode(
                  transaction.amount,
                  transaction.gateway.currency.symbol,
                  transaction.gateway.currency.code
                )
              "
            />
            <InfoRow
              :label="$t('transactions.dashboard.status')"
              :value="getStateByNumber(transaction.state)"
            />
            <InfoRow
              :label="$t('transactions.dashboard.timestamp')"
              :value="transaction.created_at | moment('LLL')"
            />
            <InfoRow
              :label="$t('transactions.dashboard.payment_method')"
              :value="getPaymentMethodById(transaction.payment_method).text"
            />
            <InfoRow
              :label="$t('transactions.details.gatewayId')"
              :value="transaction.transaction_gateway_code"
            />
            <!-- LEAD -->
            <InfoRow
              :label="$t('transactions.dashboard.donor')"
              :value="getLeadName(transaction.lead)"
            />
            <InfoRow
              :label="$t('transactions.dashboard.email')"
              :value="transaction.lead.email"
            />
            <InfoRow
              :label="$t('transactions.dashboard.donor_type')"
              :value="getLeadDonorType(transaction.lead.type)"
            />
          </v-card-text>
          <v-card-text class="ma-0 pa-0">
            <v-expansion-panels>
              <v-expansion-panel class="custom-panel">
                <v-expansion-panel-header>
                  {{ $t("transactions.details.response") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <VueJsonPretty :data="transaction.gatawey_json_response" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-container>
      <SubscriptionEditor />
    </v-container>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import BaseToolbar from "@/components/BaseToolbar";
import InfoRow from "@/components/Common/InfoRow";
import donationMixin from "@/mixins/donations";
import VueJsonPretty from "vue-json-pretty";
import SubscriptionEditor from "@/components/Subscriptions/Edit/SubscriptionEditor";

export default {
  name: "TransactionDetail",
  mixins: [donationMixin],
  components: {
    BaseToolbar,
    InfoRow,
    VueJsonPretty,
    SubscriptionEditor
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapState({
      transaction: ({ transactions: { transaction } }) => transaction
    }),
    isSubscription() {
      return !!this.transaction.is_subscription;
    }
  },
  methods: {
    ...mapMutations({
      setTransactionDetailsDrawer: "transactions/setTransactionDetailsDrawer",
      setTransaction: "transactions/setTransaction",
      setSubscriptionEditorDrawer: "transactions/setSubscriptionEditorDrawer"
    }),
    getCardTitle(transaction) {
      if (transaction.is_subscription) {
        return this.$t("transactions.dashboard.details_subs");
      } else {
        return this.$t("transactions.dashboard.details");
      }
    },
    getGatewayName(transaction) {
      if (transaction.gateway.gateway) {
        return transaction.gateway.gateway.name;
      } else {
        return "-";
      }
    },
    formatCurrencyCode(amount, symbol, code) {
      if (amount && symbol && code) {
        return `${symbol} ${amount} ${code}`;
      } else if (amount && symbol) {
        return `${symbol} ${amount}`;
      } else if (amount) {
        return amount;
      } else {
        return "-";
      }
    },
    getLeadName(lead) {
      return lead ? `${lead.first_name} ${lead.last_name}` : "-";
    },
    getLeadDonorType(type) {
      const TYPE = ["LEAD", "DONOR", "RECURRENT"];

      return TYPE[type - 1];
    },
    getTransactionType(transaction) {
      const { is_subscription, monthly_plan_charge } = transaction;

      if (!is_subscription && !monthly_plan_charge) {
        return this.$t("transactions.unique");
      } else if (!is_subscription && monthly_plan_charge) {
        return this.$t("transactions.charge");
      } else if (is_subscription) {
        return this.$t("transactions.subscription");
      } else {
        return this.$t("transactions.transaction");
      }
    },
    closeTransactionDetailDrawer() {
      this.setTransaction({});
      this.setTransactionDetailsDrawer(false);
    },
    openSubscriptionEditorDrawer() {
      this.setSubscriptionEditorDrawer(true);
    }
  }
};
</script>

<style>
.card {
  border: 1px solid #d0d5dd !important;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.15) !important;
}

.custom-panel {
  border-radius: 8px !important;
  border: 1px solid #d0d3db !important;
}
</style>
